/**
 * Drives a visible “source” badge on the job detail compensation card so users
 * immediately see whether pay is from the listing, a market estimate, or an
 * unverified numeric extraction.
 */

export type JobSalarySourceBadgeKind =
  | 'estimated_benchmark'
  | 'stated_in_listing'
  | 'unverified_numeric';

function hasPositiveSalaryRange(salaryRangeMin: unknown, salaryRangeMax: unknown): boolean {
  return (
    typeof salaryRangeMin === 'number' &&
    typeof salaryRangeMax === 'number' &&
    Number.isFinite(salaryRangeMin) &&
    Number.isFinite(salaryRangeMax) &&
    salaryRangeMin > 0 &&
    salaryRangeMax > 0
  );
}

export function resolveJobSalarySourceBadgeKind(input: {
  salaryIsEstimate?: boolean | null;
  salaryRangeMin?: number | null;
  salaryRangeMax?: number | null;
  salaryDetails?: string | null;
}): JobSalarySourceBadgeKind | null {
  if (!hasPositiveSalaryRange(input.salaryRangeMin, input.salaryRangeMax)) {
    return null;
  }
  if (input.salaryIsEstimate === true) {
    return 'estimated_benchmark';
  }
  const detail = typeof input.salaryDetails === 'string' ? input.salaryDetails.trim() : '';
  if (detail.length > 0) {
    return 'stated_in_listing';
  }
  return 'unverified_numeric';
}
